import React, { useEffect, useState } from 'react';
import haLogo from '../img/ha_logo.gif';
import { makeStyles } from "@mui/styles";
import { Typography, Grid, Paper, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { enTitle, cnTitle, enDisclaimer, cnDisclaimer } from '../utils/static';

const useStyles = makeStyles((theme) => ({
    logo: {
        position: 'absolute',
        left: 5,
        verticalAlign: 'middle',
        [theme.breakpoints.down("sm")]: {
            position: 'relative',
            width: '32%',
            left: 0,
            top: 5
        }
    },
    title: {
        display: 'inline-block',
        //color: 'rgb(0, 112, 192)',
        color: '#ed3587',
        fontSize: 30,
        fontWeight: 'bold',
        left: 45,
        position: 'relative',
        verticalAlign: 'middle',
        textAlign: 'center',
        width: '50%',
        [theme.breakpoints.down("md")]: {
            fontSize: 20,
            //left: 0,
            width: '50%'
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: 10,
            left: 0,
            width: '100%'
        }
    },
    star: {
        color: '#f44336'
    },
    paper: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        color: theme.palette.text.primary,
        borderRadius: "25px !important"
    },
    submitButton: {
        fontSize: "18px",
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6)
    },
    subTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        textDecoration: 'underline',
        marginBottom: 10
    }
}));

export default function Result() {
    const classes = useStyles();
    const { state } = useLocation();
    const navigate = useNavigate();

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null)



    useEffect(() => {
        //monitor press F5
        const isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
        const eventName = isOnIOS ? "pagehide" : "beforeunload";

        window.addEventListener(eventName, () => handleRefresh());

        if (!state || Object.keys(state).length === 0) {
            navigate('/ScanCode')
        } else {
            const period = state.info.leaveDate.period;
            if (period) {
                setFromDate(state.info.leaveDate.fromDate + " " + period);
                setToDate(state.info.leaveDate.toDate + " " + period);
            } else {
                setFromDate(state.info.leaveDate.fromDate + " ");
                setToDate(state.info.leaveDate.toDate + " ");
            }
        }

        return document.removeEventListener(eventName, () => handleRefresh());
    }, []);

    const handleRefresh = (e) => {
        navigate('/ScanCode');
    }

    const handleBack = () => {
        navigate(-1);
    }

    return state && Object.keys(state).length > 0 && (
        <div>
            <div className="page-top-heading">
                <img src={haLogo} alt="logo" className={classes.logo} />
                <div className={classes.title}>
                    {enTitle}
                    <br />
                    {cnTitle}
                </div>
            </div>
            <div style={{ marginLeft: "20px", marginRight: "20px", marginTop: "20px" }}>
                <div style={{ margin: "10px" }}>
                    <Typography>
                        {enDisclaimer}
                        <br />
                        {cnDisclaimer}
                    </Typography>
                </div>

                <Paper elevation={5} className={classes.paper}>
                    <div className={classes.subTitle}>
                        Patient Information 病人資料
                    </div>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            Name 姓名: {state.info.patientName}
                        </Grid>
                        <Grid item xs={12}>
                            Sick Leave Date 病假日期 (DD-MM-YYYY): {`Leave from 由 ${fromDate} leave to 至 ${toDate}`}
                        </Grid>
                    </Grid>
                </Paper>

                <div className={classes.subTitle} style={{ textDecoration: 'none', marginTop: 20 }}>
                    Verification Result 核對結果 : {state.result ?
                        <div>
                            The Medical Certificate is verified.
                            <br />
                            本醫生證明書通過驗證。
                        </div>
                        :
                        <div>
                            The Medical Certificate cannot be verified. Please make sure your input is correct.
                            <br />
                            無法驗證本醫生證明書。請確保您的輸入正確。
                        </div>
                    }
                </div>
                {!state.result &&
                    <div style={{ textAlign: "center" }}>
                        <Button
                            id="backBtn"
                            name="backBtn"
                            variant="contained"
                            color="primary"
                            className={classes.submitButton}
                            onClick={handleBack}
                        >
                            Back
                            <br />
                            返回
                        </Button>
                    </div>
                }

            </div>
        </div >
    );
}